import store from "../store/store";

export const generateLinks = (coordinates = []) => {
  // Use "Current+Location" as the starting point for Google Maps
  const googleMapsLink = `https://www.google.com/maps/dir/Current+Location/${coordinates
    .map((coord) => `${coord.lat},${coord.lng}`)
    .join("/")}`;

  // Waze does not support a placeholder for current location, so it would still start from the delivery center
  const deliveryCenter = store.getState().deliveryCenter.deliveryCenter;
  const wazeLink = `https://www.waze.com/ul?ll=${deliveryCenter.lat},${
    deliveryCenter.lng
  }&navigate=yes&zoom=17&coordinates=${coordinates
    .map((coord) => `${coord.lat},${coord.lng}`)
    .join("|")}`;

  return { googleMapsLink, wazeLink };
};

export const sendWhatsAppLinkMessage = (
  phoneNumber,
  googleMapsLink,
  wazeLink
) => {
  // Sanitize the phone number: remove all non-numeric characters
  const sanitizedPhoneNumber = phoneNumber.replace(/[^\d]/g, "");

  // Add country code +55
  const phoneNumberWithCountryCode = `+55${sanitizedPhoneNumber}`;

  // Create the message with URL encoding
  const message = encodeURIComponent(
    `Olá!\nSegue link com as rotas de entrega dos seus pedidos atuais:\n\nGoogle Maps: ${googleMapsLink}\n\nWaze: ${wazeLink}`
  );

  // Construct the WhatsApp link
  const whatsappLink = `https://api.whatsapp.com/send?phone=${phoneNumberWithCountryCode}&text=${message}`;

  // Open WhatsApp in a new window
  window.open(whatsappLink, "_blank");
};
